import React, { Component } from 'react';
import tr from '../../../libs/tr'
import './CartProdPnl.css';
// import crdscia from '../../../images/public/userarea/crdscia.png';
// import crdscis from '../../../images/public/userarea/crdscis.png';
// import crdscij from '../../../images/public/userarea/crdscij.png';
// import crdscib from '../../../images/public/userarea/crdscib.png';
// import crdpagana from '../../../images/public/userarea/crdpagana.png';
// import crdpaganj from '../../../images/public/userarea/crdpaganj.png';
// import crdpaganb from '../../../images/public/userarea/crdpaganb.png';

class CartProdPnl extends Component {

    constructor(props) {
        super(props);
        console.log("[CartProdPnl] @props: ", props);

        this.CartProdPnlCB = this.CartProdPnlCB.bind(this);
        this.state = {
            Adult: false, // True when the skier is Adult
            Senior: false, // True when the skier is Senior
            Junior: false, // True when the skier is Junior
            Baby: false, // True when the skier is Baby
            iDontHaveCard: props.cardNumber == 'new' || props.cardNumber == '' || props.cardNumber == "undefined",
        };

        // this.shipped = props.shipped ? props.shipped : false;
        // this.owned = props.owned ? props.owned : true;
        this.numof = props.numof ? props.numof : "1";
        this.index = props.index ? props.index : 0;
        this.mobileViewcart = props.mobileViewcart ? props.mobileViewcart : false;
    }
    CartProdPnlCB(info) {
        this.props.callback(info);
    }

    render() {
        return (
            <div>
                {!this.mobileViewcart ?
                    <div>
                        <div className="cartPnl" style={{ flex: 1 }}>
                            {tr.t("Card")} {this.numof}
                            <div className="prodPnl" style={{ flex: 1 }}>
                                <div className="cardTypel" style={{ flex: 1 }}>
                                    <img src={this.props.cardImage} className="responsiveCardl" />
                                </div>
                                <div className="actPnll" style={{ flex: 1 }}>
                                    <div className="titlePnlcl" style={{ flex: 1 }}>
                                        <div className="lineCI1l" style={{ flex: 1 }}>
                                            {tr.t("Holder")}:
                                        </div>
                                        <div className="lineCI2l" style={{ flex: 1 }}>
                                            {tr.t("Card")}:
                                        </div>
                                        <div className="lineCI3l" style={{ flex: 1 }}>
                                            {this.state.iDontHaveCard ? <div>{tr.t("State")}:</div> : null}
                                            {!this.state.iDontHaveCard ? <div>{tr.t("Cardnumber")}:</div> : null}
                                        </div>
                                    </div>
                                    <div className="insertedPnlcl" style={{ flex: 1 }}>
                                        <div className="lineCI1r" style={{ flex: 1 }}>
                                            {this.props.fullName}
                                        </div>
                                        <div className="lineCI2r" style={{ flex: 1 }}>
                                            {tr.t(this.props.cardType)}
                                        </div>
                                        <div className="lineCI3r" style={{ flex: 1 }}>
                                            {this.state.iDontHaveCard ? <div>{(this.props.shipped) ? tr.t("Inship") : tr.t("TobeCollected")}</div> : null}
                                            <strong className="txlscppSmaller">{!this.state.iDontHaveCard ? <div>{this.props.cardNumber}</div> : null}</strong>
                                        </div>
                                        <div className="lineCI4r" style={{ flex: 1 }}>
                                            {this.props.price}
                                        </div>
                                    </div>
                                </div>
                                <button className="sbtnl" onClick={() => this.CartProdPnlCB({ action: "remove", index: this.index })}>{tr.t("Removecard")}</button>
                            </div>
                        </div>
                    </div> : null
                }

                {this.mobileViewcart ?
                    <div>
                        <div className="cartPnlm" style={{ flex: 1 }}>
                            {tr.t("Card")} {this.numof}
                            <div className="prodPnlm" style={{ flex: 1 }}>
                                <div className="cardTypelm" style={{ flex: 1 }}>
                                    <img src={this.props.cardImage} className="responsiveCardl" />
                                </div>
                                <div className="actPnllm" style={{ flex: 1 }}>
                                    <div className="titlePnlclm" style={{ flex: 1 }}>
                                        <div className="lineCI1lm" style={{ flex: 1 }}>
                                            {tr.t("Holder")}:
                                        </div>
                                        <div className="lineCI2lm" style={{ flex: 1 }}>
                                            {tr.t("Card")}:
                                        </div>
                                        <div className="lineCI3lm" style={{ flex: 1 }}>
                                            {this.state.iDontHaveCard ? <div>{tr.t("State")}:</div> : null}
                                            {!this.state.iDontHaveCard ? <div>{tr.t("Cardnumber")}:</div> : null}
                                        </div>
                                    </div>
                                    <div className="insertedPnlclm" style={{ flex: 1 }}>
                                        <div className="lineCI1rm" style={{ flex: 1 }}>
                                            {this.props.fullName}
                                        </div>
                                        <div className="lineCI2rm" style={{ flex: 1 }}>
                                            {tr.t(this.props.cardType)}
                                        </div>
                                        <div className="lineCI3rm" style={{ flex: 1 }}>
                                            {this.state.iDontHaveCard ? <div>{(this.props.shipped) ? tr.t("Inship") : tr.t("TobeCollected")}</div> : null}
                                            <strong className="txlscppSmallerm">{!this.state.iDontHaveCard ? <div>{this.props.cardNumber}</div> : null}</strong>
                                        </div>
                                        <div className="lineCI4rm" style={{ flex: 1 }}>
                                            {this.props.price}
                                        </div>
                                    </div>
                                </div>
                                <button className="sbtnlm" onClick={() => this.CartProdPnlCB({ action: "remove", index: this.index })}>{tr.t("Removecard")}</button>
                            </div>
                        </div>
                    </div> : null
                }
            </div>
        );
    }
}

export default CartProdPnl;


// WEBPACK FOOTER //
// ./src/assets/components/panel/CartProdPnl.js